import React, { useState,useRef, useEffect } from 'react';
import {
  TextField,
  Button,
  Select,
  InputLabel,
  FormControl,
  Typography,
  MenuItem,
  Box,
  Paper,
  Tab,
  Tabs,
  TextareaAutosize
} from '@mui/material';
import useApi from '../../api/useApi';
import { ClassTeacherCreate } from '../../api/teacherService';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import { Navigate, useNavigate } from 'react-router';
import { ArticleCreate, OrgCreate } from '../../api/orgService';
import SubCategorySelect from '../Admin/Consumer/SubCategorySelect';
// import { Form, TextArea } from 'semantic-ui-react'
// import { useNavigationTab } from '../../hooks/useNavigationTab';


const ArticleCreateForm = ({allTopics,allSubtopics,setSelected}) => {
    const navigate = useNavigate()

  const [form, setForm] = useState({
    org_name: '',
    org_description: '',
    org_tag: '',
    owner: '',
    title:"",
    description:"",
    img:"",
    category:"",
    subcategory:"",
  });

  const { user } = useAuth();
  // const navigate=useNavigate()
  // const {customNavigate} = useNavigationTab()

  const { request:createArticle,data:createArticleData,error:createArticleError,isLoading:createArticleIsLoading}=useApi(ArticleCreate)


  const handleChange = (e) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleChangeCategory = (id) => {
    setForm(prev => ({
      ...prev,
      category: id
    }));;
  };

  const handleChangeSubCategory = (idSub) => {
    console.log(idSub)
    setForm(prev => ({
      ...prev,
      subcategory: idSub
    }));;
  };

  // const handleFormUrlChange = (e,res) => {
  //   setForm({ ...form, [e.target.name]: res });
  // };

  
 

  useEffect(()=>{
    if(createArticleData){
      if(createArticleData?.status===201){
        toast.success(`${JSON.stringify(createArticleData?.statusText)}, successful`,{position: "top-center"});
        // customNavigate("/t","","home",{refresh:"classes"})
        navigate("/staff/articles/")
      }
    }
  },[createArticleData])

  useEffect(()=>{
    if(createArticleError){

        toast.error(`${JSON.stringify(createArticleError?.response?.data,null,2)}`,{position: "top-center"});
    }
  },[createArticleError])



  const  okayToSubmit =  !form.title?.length>0 || !form.description?.length>0

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Article input:', form);
    form.created_by = user?.user?.id
    const dataToSend = {
    //   publisher:form.created_by,
    publisher:user?.user?.id,
    title:form.title,
    description:form.description,
    img:form.img,
    //   category:form.category,
    category:parseInt(form.category),
    //   subcategory:form.subcategory,
    sub_category:parseInt(form.subcategory),
    project:1
    }

    console.log('Article sending:', dataToSend);
    createArticle(dataToSend)

    // Add API request logic here
  };
  return (
    <Box display="flex" justifyContent="center" width="100%">
    <Box display="flex" flexDirection="column" justifyContent="center" mt={4} width={700}>

        <div>
          
          <Typography variant="h5" gutterBottom>
            Create a new Article
          </Typography>
        </div>
          
          <Typography variant='p' component="p" color='#404040'>
          An Article is used to publish any information about the organisation 
          activities, projects, posts, <br/>news and campaigns. Use articles as an explainer to put more details  about the organisation.

          </Typography>
          <form onSubmit={handleSubmit} style={{marginTop:30}}>
            
          <i>Required fields are marked with an asterisk (*).</i>

            <TextField
              fullWidth
              label="Title"
              name="title"
              value={form.title}
              onChange={handleChange}
              margin="normal"
              required
              
            />

            
            <Typography variant='p' component="p" color='#404040'>
            Write a brief summary statement or description that explains about the main point point of the article.
            </Typography>
           
            <TextField
              fullWidth
              label="Description"
              name="description"
              value={form.description}
              onChange={handleChange}
              margin="normal"
              required
            />

            <SubCategorySelect setCategoryId={handleChangeCategory } setSubCategoryId={handleChangeSubCategory } />
            {/* <TextField
              fullWidth
              label="Organisation tag Name"
              name="org_tag"
              value={form.subcategory}
              onChange={handleChange}
              margin="normal"
              required
            /> */}

            {/* <TextField
              fullWidth
              label="Organisation tag Name"
              name="org_tag"
              value={form.category}
              onChange={handleChange}
              margin="normal"
              required
            /> */}
            
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 1 ,mb:5}}
              disabled={okayToSubmit}
            >
              Create Article
            </Button>
          </form>
      </Box>
    </Box>
  );
};


export default ArticleCreateForm